/**
 * Roomgrid notification — react-admin's Notification re-anchored to the
 * bottom-center (inverted toast look comes from the MuiSnackbarContent
 * override in the theme).
 */

import React from "react";
import { Notification } from "react-admin";

export const RgNotification: React.FC = () => (
  <Notification
    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    autoHideDuration={3000}
  />
);

export default RgNotification;
